var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("title-component"),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-form", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-sm-6" },
                [
                  _c("card-title-component", {
                    attrs: { title: _vm.$t("profile.basicInformation.title") }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "firstname-form-group",
                                label: _vm.$t(
                                  "profile.basicInformation.firstname"
                                ),
                                "label-for": "firstname-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "o-form",
                                class: {
                                  "o-form--state-danger": _vm.errors.has(
                                    "firstname-input-name"
                                  )
                                },
                                attrs: {
                                  id: "firstname-input",
                                  name: "firstname-input-name",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.basicInformation.firstname"
                                  )
                                },
                                model: {
                                  value: _vm.localFirstname,
                                  callback: function($$v) {
                                    _vm.localFirstname = $$v
                                  },
                                  expression: "localFirstname"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors.first("firstname-input-name")
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "lastname-form-group",
                                label: _vm.$t(
                                  "profile.basicInformation.lastname"
                                ),
                                "label-for": "lastname-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "lastname-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.basicInformation.lastname"
                                  )
                                },
                                model: {
                                  value: _vm.localLastname,
                                  callback: function($$v) {
                                    _vm.localLastname = $$v
                                  },
                                  expression: "localLastname"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "address-form-group",
                                label: _vm.$t(
                                  "profile.basicInformation.address"
                                ),
                                "label-for": "address-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "address-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.basicInformation.address"
                                  )
                                },
                                model: {
                                  value: _vm.localAddress,
                                  callback: function($$v) {
                                    _vm.localAddress = $$v
                                  },
                                  expression: "localAddress"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "address-extra-line-form-group",
                                label: _vm.$t(
                                  "profile.basicInformation.addressExtraInformation"
                                ),
                                "label-for": "address-extra-line-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "address-extra-line-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.basicInformation.addressExtraInformation"
                                  )
                                },
                                model: {
                                  value: _vm.localExtraAddressLine,
                                  callback: function($$v) {
                                    _vm.localExtraAddressLine = $$v
                                  },
                                  expression: "localExtraAddressLine"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "zipcode-form-group",
                                label: _vm.$t(
                                  "profile.basicInformation.zipcode"
                                ),
                                "label-for": "zipcode-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "firstname-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.basicInformation.zipcode"
                                  )
                                },
                                model: {
                                  value: _vm.localZipcode,
                                  callback: function($$v) {
                                    _vm.localZipcode = $$v
                                  },
                                  expression: "localZipcode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "city-form-group",
                                label: _vm.$t("profile.basicInformation.city"),
                                "label-for": "city-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "city-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.basicInformation.city"
                                  )
                                },
                                model: {
                                  value: _vm.localCity,
                                  callback: function($$v) {
                                    _vm.localCity = $$v
                                  },
                                  expression: "localCity"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-sm-6" },
                [
                  _c("card-title-component", {
                    attrs: { title: _vm.$t("profile.contactInformation.title") }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "email-form-group",
                                label: _vm.$t(
                                  "profile.contactInformation.email"
                                ),
                                "label-for": "email-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "email-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.contactInformation.email"
                                  )
                                },
                                model: {
                                  value: _vm.localEmail,
                                  callback: function($$v) {
                                    _vm.localEmail = $$v
                                  },
                                  expression: "localEmail"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "mobile-form-group",
                                label: _vm.$t(
                                  "profile.contactInformation.mobile"
                                ),
                                "label-for": "mobile-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "mobile-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.contactInformation.mobile"
                                  )
                                },
                                model: {
                                  value: _vm.localMobile,
                                  callback: function($$v) {
                                    _vm.localMobile = $$v
                                  },
                                  expression: "localMobile"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "phone-form-group",
                                label: _vm.$t(
                                  "profile.contactInformation.phone"
                                ),
                                "label-for": "phone-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "phone-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.contactInformation.phone"
                                  )
                                },
                                model: {
                                  value: _vm.localPhone,
                                  callback: function($$v) {
                                    _vm.localPhone = $$v
                                  },
                                  expression: "localPhone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "website-form-group",
                                label: _vm.$t(
                                  "profile.contactInformation.website"
                                ),
                                "label-for": "website-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "website-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.contactInformation.website"
                                  )
                                },
                                model: {
                                  value: _vm.localWebsite,
                                  callback: function($$v) {
                                    _vm.localWebsite = $$v
                                  },
                                  expression: "localWebsite"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 col-sm-6" },
                [
                  _c("card-title-component", {
                    attrs: { title: _vm.$t("profile.detailInformation.title") }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "profession-form-group",
                                label: _vm.$t(
                                  "profile.detailInformation.profession"
                                ),
                                "label-for": "profession-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "profession-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.detailInformation.profession"
                                  )
                                },
                                model: {
                                  value: _vm.localProfession,
                                  callback: function($$v) {
                                    _vm.localProfession = $$v
                                  },
                                  expression: "localProfession"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "employer-form-group",
                                label: _vm.$t(
                                  "profile.detailInformation.employer"
                                ),
                                "label-for": "employer-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "employer-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.detailInformation.employer"
                                  )
                                },
                                model: {
                                  value: _vm.localEmployer,
                                  callback: function($$v) {
                                    _vm.localEmployer = $$v
                                  },
                                  expression: "localEmployer"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "birthdate-form-group",
                                label: _vm.$t(
                                  "profile.detailInformation.birthdate"
                                ),
                                "label-for": "birthdate-input"
                              }
                            },
                            [
                              _c("datepicker", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "birthdate-input",
                                  format: "dd.MM.yyyy",
                                  language: this.getLanguage()
                                },
                                model: {
                                  value: _vm.localBirthdate,
                                  callback: function($$v) {
                                    _vm.localBirthdate = $$v
                                  },
                                  expression: "localBirthdate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "ahv-number-form-group",
                                label: _vm.$t(
                                  "profile.detailInformation.ahvNumber"
                                ),
                                "label-for": "ahv-number-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "ahv-number-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.detailInformation.ahvNumber"
                                  )
                                },
                                model: {
                                  value: _vm.localAHVNumber,
                                  callback: function($$v) {
                                    _vm.localAHVNumber = $$v
                                  },
                                  expression: "localAHVNumber"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "place-of-origin-form-group",
                                label: _vm.$t(
                                  "profile.detailInformation.placeOfOrigin"
                                ),
                                "label-for": "place-of-origin-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "place-of-origin-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.detailInformation.placeOfOrigin"
                                  )
                                },
                                model: {
                                  value: _vm.localPlaceOfOrigin,
                                  callback: function($$v) {
                                    _vm.localPlaceOfOrigin = $$v
                                  },
                                  expression: "localPlaceOfOrigin"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "marital-status-form-group",
                                label: _vm.$t(
                                  "profile.detailInformation.maritalStatus"
                                ),
                                "label-for": "marital-status-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "marital-status-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.detailInformation.maritalStatus"
                                  )
                                },
                                model: {
                                  value: _vm.localMaritalStatus,
                                  callback: function($$v) {
                                    _vm.localMaritalStatus = $$v
                                  },
                                  expression: "localMaritalStatus"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "health-insurance-1-form-group",
                                label: _vm.$t(
                                  "profile.detailInformation.healthInsurance1"
                                ),
                                "label-for": "health-insurance-1-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "health-insurance-1-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.detailInformation.healthInsurance1"
                                  )
                                },
                                model: {
                                  value: _vm.localHealthInsurance1,
                                  callback: function($$v) {
                                    _vm.localHealthInsurance1 = $$v
                                  },
                                  expression: "localHealthInsurance1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "health-insurance-2-form-group",
                                label: _vm.$t(
                                  "profile.detailInformation.healthInsurance2"
                                ),
                                "label-for": "health-insurance-2-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "health-insurance-2-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.detailInformation.healthInsurance2"
                                  )
                                },
                                model: {
                                  value: _vm.localHealthInsurance2,
                                  callback: function($$v) {
                                    _vm.localHealthInsurance2 = $$v
                                  },
                                  expression: "localHealthInsurance2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 col-sm-6" },
                [
                  _c("card-title-component", {
                    attrs: { title: _vm.$t("profile.furtherInformation.title") }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "form-group",
                                label: _vm.$t(
                                  "profile.furtherInformation.organDonor"
                                ),
                                "label-for": "organdonor-input"
                              }
                            },
                            [
                              _c("b-form-checkbox", {
                                attrs: { id: "organdonor-input-id" },
                                model: {
                                  value: _vm.localOrganDonor,
                                  callback: function($$v) {
                                    _vm.localOrganDonor = $$v
                                  },
                                  expression: "localOrganDonor"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "form-group",
                                label: _vm.$t(
                                  "profile.furtherInformation.patientsProvision"
                                ),
                                "label-for": "patientsProvision-input"
                              }
                            },
                            [
                              _c("b-form-checkbox", {
                                attrs: { id: "patientsProvision-input-id" },
                                model: {
                                  value: _vm.localPatientsProvision,
                                  callback: function($$v) {
                                    _vm.localPatientsProvision = $$v
                                  },
                                  expression: "localPatientsProvision"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "religion-form-group",
                                label: _vm.$t(
                                  "profile.furtherInformation.religion"
                                ),
                                "label-for": "religion-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "religion-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.furtherInformation.religion"
                                  )
                                },
                                model: {
                                  value: _vm.localReligion,
                                  callback: function($$v) {
                                    _vm.localReligion = $$v
                                  },
                                  expression: "localReligion"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "o-label",
                              attrs: {
                                id: "confession-form-group",
                                label: _vm.$t(
                                  "profile.furtherInformation.confession"
                                ),
                                "label-for": "confession-input"
                              }
                            },
                            [
                              _c("b-form-input", {
                                staticClass: "o-form",
                                attrs: {
                                  id: "confession-input",
                                  type: "text",
                                  required: "",
                                  placeholder: _vm.$t(
                                    "profile.furtherInformation.confession"
                                  )
                                },
                                model: {
                                  value: _vm.localConfession,
                                  callback: function($$v) {
                                    _vm.localConfession = $$v
                                  },
                                  expression: "localConfession"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col button-div" },
          [
            _c(
              "b-button",
              { staticClass: "save-button o-button", on: { click: _vm.save } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("profile.saveButton")) +
                    "\n            "
                )
              ]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d8cbf84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d8cbf84","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileComponent.vue
// module id = null
// module chunks = 